export const toTitleCase = (
  str: string | undefined | null
) => {
  if (str === null || str === '') return '';
  else str = str?.toString();

  return (
    str?.replace(/\w\S*/g, function (txt) {
      return (
        txt.charAt(0).toUpperCase() +
        txt.substr(1).toLowerCase()
      );
    }) || '-'
  );
};

export const getStringAfterMatching = (
  inputString: string | undefined | null,
  matchingString: string
): string | undefined => {
  if (inputString === undefined || inputString === null) {
    return undefined;
  }
  const index: number = inputString.indexOf(matchingString);
  if (index !== -1) {
    return inputString.substring(
      index + matchingString.length
    );
  } else {
    return undefined;
  }
};
